import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      statuses: [],
      reference: null
    }
  },
  getters: {
    statuses (state) {
      return state.statuses
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.statuses = payload
    },
    add (state, payload) {
      state.statuses.push(payload)
    },
    update (state, payload) {
      const index = state.statuses.findIndex(item => item.key === payload.key)
      if (index !== -1) {
        Vue.set(state.statuses, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.statuses.findIndex(item => item.key === payload.key)
      if (index !== -1) {
        state.statuses.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('status')
        var reference = dbRef.onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            data['key'] = change.doc.id
            if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['statuses/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}
